// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoomContact } from './RoomContact';
import {
    RoomContactFromJSON,
    RoomContactFromJSONTyped,
    RoomContactToJSON,
    RoomContactToJSONTyped,
} from './RoomContact';
import type { RoomMonitoring } from './RoomMonitoring';
import {
    RoomMonitoringFromJSON,
    RoomMonitoringFromJSONTyped,
    RoomMonitoringToJSON,
    RoomMonitoringToJSONTyped,
} from './RoomMonitoring';

/**
 * 
 * @export
 * @interface RoomMetaInput
 */
export interface RoomMetaInput {
    /**
     * 
     */
    contact?: RoomContact;
    /**
     * Room number
     */
    number?: string;
    /**
     * Room name
     */
    name?: string;
    /**
     * 
     */
    monitoring?: Array<RoomMonitoring>;
    /**
     * Hide the room from end-user views (still listed in admin)
     */
    hidden?: boolean;
}

/**
 * Check if a given object implements the RoomMetaInput interface.
 */
export function instanceOfRoomMetaInput(value: object): value is RoomMetaInput {
    return true;
}

export function RoomMetaInputFromJSON(json: any): RoomMetaInput {
    return RoomMetaInputFromJSONTyped(json, false);
}

export function RoomMetaInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomMetaInput {
    if (json == null) {
        return json;
    }
    return {
        
        'contact': json['contact'] == null ? undefined : RoomContactFromJSON(json['contact']),
        'number': json['number'] == null ? undefined : json['number'],
        'name': json['name'] == null ? undefined : json['name'],
        'monitoring': json['monitoring'] == null ? undefined : ((json['monitoring'] as Array<any>).map(RoomMonitoringFromJSON)),
        'hidden': json['hidden'] == null ? undefined : json['hidden'],
    };
}

export function RoomMetaInputToJSON(json: any): RoomMetaInput {
    return RoomMetaInputToJSONTyped(json, false);
}

export function RoomMetaInputToJSONTyped(value?: RoomMetaInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contact': RoomContactToJSON(value['contact']),
        'number': value['number'],
        'name': value['name'],
        'monitoring': value['monitoring'] == null ? undefined : ((value['monitoring'] as Array<any>).map(RoomMonitoringToJSON)),
        'hidden': value['hidden'],
    };
}

